import React, { useState } from 'react';
import {
  makeStyles,
  Avatar,
  List,
  Divider,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon,
  DialogTitle,
  Box,
  Dialog,
  Typography,
} from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import FaceIcon from '@material-ui/icons/Face';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import BlacklistTextField from './fruit-profile-blacklist';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import {usePreferenceContext} from 'src/context/PreferenceContext';
import {fruitHasValidateLockFromOthers} from './fruit-profile-single/utils/smart-filtering';
import {mergedFruit} from 'src/views/harvesting/fruit-profile/fruit-profile-single/utils/document-version-reader';
import { useAuthContext } from 'src/context/AuthContext';

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  dialog: {
    padding: 0,
  },
  inline: {},
  link: {},
  name: {},
  listItem: {},
});

interface FruitProfilePopupType {
  fruit: FruitPropsType;
  checkData: FruitPropsType| false;
  checkDataold:any;
  isOpen: boolean;
  closeLightBox: () => void;
  other:any
}

const FruitProfilePopup: React.FC<FruitProfilePopupType> = ({
  fruit,
  checkData,
  checkDataold,
  isOpen,
  closeLightBox,
  other
}) => {
  const classes = useStyles();
  // const { onClose, lightBox } = props;

  const { setFruitTexted, removeFruit,setFruitAsMember, setFruitAsPastor,setFruitAsUnTexted } = useHarvestingContext();
 
  const {fruitsTab} = usePreferenceContext();
  const [banOption, setBanOption] = useState(false);

  const handleClose = () => {
    setBanOption(false);
    closeLightBox();
  };

  const setReport = (fruit: FruitPropsType) => {
    // const filtedOutput = output.filter((x) => x.name !== fruit.name);
    
    setFruitTexted(fruit,checkData);

    // handleClose();
  };
  const removeFromOutput = (fruit: FruitPropsType) => {
    removeFruit(fruit,checkDataold);
    // handleClose();
  };

  const memberOption = (fruit: FruitPropsType) => {
    setFruitAsMember(fruit,checkData);
    // handleClose();
  };

  const pastorOption = (fruit: FruitPropsType) => {
    setFruitAsPastor(fruit,checkData);
    // handleClose();
  };
  const mergeFruits =mergedFruit(fruit,checkData);
  const {user} = useAuthContext();

  const lockedList = fruitHasValidateLockFromOthers(mergeFruits,user.name);
  const ListOfOptions = () => {
    return (
      <>
        {other}
        {fruitsTab==='Available'&&(
          <List>
            <ListItem button dense onClick={() => setReport(fruit)}>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="I have messaged him/her" />
            </ListItem>
          </List>
        )}
        {fruitsTab==='Available'&&(
          <List>
            <ListItem
              
              button
              dense
              onClick={() => removeFromOutput(fruit)}
            >
              <ListItemIcon>
                <CancelIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Not Good, Remove from List Please!" />
            </ListItem>
          </List>
        )}

        {fruitsTab==='Texted'&&(
          <List>
            <ListItem
              
              button
              dense
              onClick={() => setFruitAsUnTexted(checkData)}
            >
              <ListItemIcon>
                <CancelIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Untext this fruit please" />
            </ListItem>
          </List>
        )}


        <List>
          <ListItem
            
            button
            dense
            onClick={() => memberOption(fruit)}
          >
            <ListItemIcon>
              <FaceIcon style={{ color: 'rgb(167 38 0)' }} />
            </ListItemIcon>
            <ListItemText primary="Our family member" />
          </ListItem>
        </List>
        <List>
          <ListItem
            
            button
            dense
            onClick={() => pastorOption(fruit)}
          >
            <ListItemIcon>
              <EmojiPeopleIcon style={{ color: '#64008e' }} />
            </ListItemIcon>
            <ListItemText primary="A Pastor/Priest" />
          </ListItem>
        </List>

        <List>
          <ListItem
            
            button
            dense
            onClick={() => {
              setBanOption(true);
            }}
          >
            <ListItemIcon>
              <RemoveCircle style={{ color: '#dc0a14' }} />
            </ListItemIcon>
            <ListItemText primary="Blacklist" />
          </ListItem>
        </List>
      </>
    );
  };
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="profile-dialog-lightbox"
      open={Object.keys(fruit).length !== 0}
    >
      <DialogTitle id="profile-dialog-lightbox" className={classes.dialog}>
        <ListItem alignItems="flex-start" className={classes.listItem}>
          <div className={classes.link}>
            <ListItemAvatar>
              <Avatar
                alt={fruit.name}
                src={
                  !!fruit.image && fruit.image !== ''
                    ? fruit.image
                    : `https://icotar.com/initials/${fruit.name}`
                }
              />
            </ListItemAvatar>
          </div>
          {!!fruit && (
            <ListItemText
              primary={<div className={classes.name}> {fruit.name}</div>}
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    className={classes.inline}
                    color="textPrimary"
                  >
                    {/* {fruit.platform !==undefined&&fruit.platform} */}
                    {/* {fruit.Platform ===undefined&&fruit.Platform} */}
                  </Typography>
                  {fruit.others !== '' &&fruit.others !== undefined && ' — ' + fruit.others}
                </React.Fragment>
              }
            />
          )}
        </ListItem>
      </DialogTitle>
      <Divider component="li" />
      {lockedList.length>0?
        <>
          <Box p={2}>
          OPPS!&nbsp;{lockedList.map(lock=>{
              return lock.name;
            }).join(', ')}&nbsp;is also messaging at this fruit!
          </Box>
          <List>
            <ListItem
              button
              dense
              onClick={() => closeLightBox()}
            >
              <ListItemIcon>
                <CancelIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Text this fruit later" />
            </ListItem>
          </List>
        </>
        :!banOption ? (
          <ListOfOptions />
        ) : (
          <Box p={2}>
            <BlacklistTextField
              fruit={fruit}
              backFunc={() => setBanOption(false)}
              checkDate={checkData}
              handleClose={() => handleClose()}
            />
         
          </Box>
        )}
    </Dialog>
  );
};

export default FruitProfilePopup;
